<template>
    <div>
        <div class="flex-child" v-for="trophy in achievedTrophies" :key="trophy.id">
            <trophy style="width: 90%;" size="57" :displayOnly="true" :trophy="trophy" :showTitle="false"
                :showDesc="false" orientation="horizontal">
            </trophy>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import filter from 'lodash.filter';

export default {
    props: {
        user_id: {
            required: true,
        }
    },

    computed: {
        ...mapState([
            'trophies'
        ]),

        achievedTrophies() {
            return filter(this.trophies, function (trophy) {
                return trophy.category === 'custom' || trophy.progress >= 100
            });
        },
    },

    mounted() {
        this.$store.dispatch('getAchievements', this.user_id);
    },
}
</script>

<style lang="scss" scoped>
.flex-child {
    flex-basis: 50px;
    height: 50px;
    margin-right: 10px;
}
</style> 
